var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-max",
      class: { "p-0": _vm.$ceres.isShopBuilder }
    },
    [
      _c(
        "div",
        { staticClass: "position-relative" },
        [
          _c(
            "div",
            { staticClass: "d-flex flex-grow-1 position-relative my-2" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchString,
                    expression: "searchString"
                  }
                ],
                ref: "searchInput",
                staticClass: "search-input flex-grow-1 px-3 py-2",
                attrs: {
                  type: "search",
                  autofocus: _vm.isShopBuilder,
                  placeholder: _vm.$translate(
                    "Ceres::Template.headerSearchPlaceholder"
                  ),
                  "aria-label": _vm.$translate(
                    "Ceres::Template.headerSearchTerm"
                  )
                },
                domProps: { value: _vm.searchString },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.searchString = $event.target.value
                    },
                    function($event) {
                      return _vm.onValueChanged($event.target.value)
                    }
                  ],
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.search()
                  },
                  focus: function($event) {
                    _vm.isSearchFocused = true
                  },
                  blur: function($event) {
                    return _vm.onBlurSearchField($event)
                  }
                }
              }),
              _vm._v(" "),
              _vm._t("search-button", [
                _c(
                  "button",
                  {
                    staticClass: "search-submit px-3",
                    attrs: {
                      type: "submit",
                      "aria-label": _vm.$translate(
                        "Ceres::Template.headerSearch"
                      )
                    },
                    on: {
                      click: function($event) {
                        return _vm.search()
                      }
                    }
                  },
                  [
                    _c("icon", {
                      staticClass: "fa-fw",
                      attrs: {
                        icon: "search",
                        loading: _vm.autocompleteIsLoading
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            2
          ),
          _vm._v(" "),
          _vm.isSearchFocused
            ? [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasInitialInput || _vm.$ceres.isShopBuilder,
                        expression: "hasInitialInput || $ceres.isShopBuilder"
                      }
                    ]
                  },
                  [
                    _vm._t("autocomplete-suggestions", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "autocomplete-suggestions bg-white px-3 pb-3"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "auto-item" },
                            [
                              _c(
                                "span",
                                { staticClass: "h4 d-block p-3 mb-0" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "meliorisVueTheme::Header.SuggItem"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("search-suggestion-item", {
                                attrs: {
                                  "show-images": true,
                                  "suggestion-type": "item",
                                  "show-count": true,
                                  "show-additional-information": true
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "auto-cat" },
                            [
                              _c(
                                "span",
                                { staticClass: "h4 d-block p-3 mb-0" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "meliorisVueTheme::Header.CategoryCaption"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("search-suggestion-item", {
                                attrs: {
                                  "show-images": false,
                                  "suggestion-type": "category",
                                  "show-count": false,
                                  "show-additional-information": false
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "auto-suggestion d-none d-sm-block"
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "h4 d-block p-3 mb-0" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "meliorisVueTheme::Header.SuggestionCaption"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("search-suggestion-item", {
                                attrs: {
                                  "show-images": false,
                                  "suggestion-type": "suggestion",
                                  "show-count": false,
                                  "show-additional-information": false
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  ],
                  2
                )
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }